import { Entity } from './entity';

abstract class CategoryBase extends Entity {}

export class CategoryListItem extends CategoryBase {}
